import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

const NotFoundPage = ({ }) => {
   

    return (
        <>
        <Box 
            className='verticaly-center'
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 3,
                boxSizing: 'border-box'
            }}
        >
            <Card
                sx={{
                    p: { xs: 4, sm: 6 },
                    borderRadius: '20px',
                    border: '1px solid #E2E8F0',
                    boxShadow: '0 10px 25px -5px rgba(15, 23, 42, 0.02), 0 8px 10px -6px rgba(15, 23, 42, 0.02)',
                    maxWidth: '480px',
                    width: '100%',
                    textAlign: 'center',
                    backgroundColor: '#FFFFFF'
                }}
            >
                <Box 
                    component="img" 
                    src="/assets/images/404.png" 
                    alt='404' 
                    sx={{ 
                        maxWidth: '220px', 
                        height: 'auto', 
                        mx: 'auto', 
                        display: 'block',
                        mb: 4,
                        opacity: 0.9
                    }}
                />
                
                <Typography 
                    variant="h4" 
                    component="h6" 
                    sx={{ 
                        fontWeight: 800, 
                        color: '#0F172A', 
                        letterSpacing: '-0.5px',
                        mb: 1.5
                    }}
                >
                    Not found
                </Typography>
                
                <Typography 
                    variant="body1" 
                    component="p"
                    sx={{ 
                        color: '#64748B', 
                        lineHeight: 1.6,
                        fontWeight: 500,
                        mb: 4,
                        px: 2
                    }}
                >
                    Sorry, the page you visited does not exist.
                </Typography>
                
                <Button 
                    href="/" 
                    variant="contained" 
                    startIcon={<ArrowBackOutlinedIcon sx={{ fontSize: '16px !important' }} />}
                    sx={{
                        px: 4,
                        py: 1.25,
                        borderRadius: '10px',
                        fontWeight: 700,
                        textTransform: 'none',
                        fontSize: '14px',
                        boxShadow: 'none',
                        backgroundColor: '#1976d2',
                        color: '#FFFFFF',
                        transition: 'all 0.2s ease-in-out',
                        '&:hover': { 
                            backgroundColor: '#115293', 
                            boxShadow: 'none' 
                        }
                    }}
                >
                    Back to Home
                </Button>
            </Card>
        </Box>
        </>
    )

}

export default NotFoundPage;